var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex ai-center jc-center h-100"},[_c('span',{staticClass:"HEADER"},[_vm._v("\n    Review"),(_vm.proName)?_c('span',[_vm._v(" "+_vm._s(_vm.proName))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }